// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__l-HXI","title":"styles_title__JJLeJ"};